export default {"src":"/_next/static/media/separator.1ca99126.svg","height":4,"width":449};